module.exports = __webpack_public_path__ + "img/PPMPRA4.26143688.png";